import { ResponsiveFloraTypography } from 'components';
import { useResellerDetail } from 'hooks';
import { getCampaignCards } from 'pages/IncentiveCampaign/helpers';

import Styles, { columnSize } from './CardInfo.styles';
import { useLoyaltyIncentiveCampaign } from '../../hooks';

export const CardInfo = () => {
  const { data: incentiveCampaign, isOptinClosed } = useLoyaltyIncentiveCampaign();
  const { data: resellerDetail } = useResellerDetail();
  const isLoyaltyMember = resellerDetail?.reseller.isLoyaltyMember ?? false;

  const cards = getCampaignCards(isLoyaltyMember, incentiveCampaign, isOptinClosed);

  return (
    <Styles.Wrapper
      style={{
        [columnSize]: cards.length,
      }}
    >
      {cards.map((cardInfo, index) => (
        <Styles.Card key={`card-${index}`}>
          <ResponsiveFloraTypography fontSize='title' fontWeight='bold'>
            {cardInfo.index}
          </ResponsiveFloraTypography>

          <ResponsiveFloraTypography fontWeight='bold'>{cardInfo.title}</ResponsiveFloraTypography>
          <>
            <ResponsiveFloraTypography color='$nonInteractiveAuxiliar'>
              {cardInfo.description}
            </ResponsiveFloraTypography>
            <ResponsiveFloraTypography fontSize='bodySmallStandard' color='$nonInteractiveAuxiliar'>
              {cardInfo.note}
            </ResponsiveFloraTypography>
          </>
        </Styles.Card>
      ))}
    </Styles.Wrapper>
  );
};
